import { uniqueId } from "lodash";
import { useState } from "react";

const Radio = ({ label, id, name, checked, onChecked, disabled }) => {
  const [radioId] = useState(id || uniqueId("radio-"));

  return (
    <div>
      <input
        className="form-check-input me-2"
        type="radio"
        id={radioId}
        name={name}
        checked={checked}
        onChange={() => onChecked(label)}
        disabled={disabled}
      />
      <label className="pt-1" htmlFor={radioId}>
        {label}
      </label>
    </div>
  );
};
export default Radio;
